import {Link} from 'gatsby';
import * as React from 'react';

import {isExternalUrl, sanitizeUrl} from '@src/utils';

import type {SubNavItem} from '@src/components/Nav';

interface DropdownMenuItemProps {
  item: SubNavItem;
}

const DropdownMenuItem: React.FC<DropdownMenuItemProps> = ({
  item: {
    sub_nav_link_label: {text},
    sub_nav_link_url: {text: to},
  },
}) => {
  if (!isExternalLink(to)) {
    return (
      <Link to={to} role="menuitem">
        {text}
      </Link>
    );
  }

  if (!isExternalUrl(to)) {
    return (
      <a role="menuitem" href={to}>
        {text}
      </a>
    );
  }

  return (
    <a role="menuitem" href={to} target="_blank" rel="noopener noreferrer">
      {text}
    </a>
  );
};

export const isExternalLink = (url: string): boolean => {
  const isAbsoluteUrl = /^((http|https):\/\/)/;
  if (!isAbsoluteUrl.test(url)) {
    return false;
  }

  return 'devoted.com' !== sanitizeUrl(url);
};

export default DropdownMenuItem;
